import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";

import ClientReportsForm from "./ClientReportsForm";
import * as dataActions from "../../../../../utils/data/dataActions";
import { POST_DATA_FILE_FAILURE } from "../../../../../utils/data/dataActionTypes";

import { CLIENTS } from "../../../../../utils/data/models";

import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { canDownload } from "../../../../common/CanDownload";
import { downloaderEnums } from "../../../../../utils/downloader/downloaderEnums";

class ClientReportsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      generating: false,
      downloadPath: null
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.buildDescription = this.buildDescription.bind(this);
    this.getReportType = this.getReportType.bind(this);
    this._initialize = this._initialize.bind(this);
  }

  componentDidMount() {
    this._initialize();
  }
  

  componentDidUpdate(){
    
    if(this.state.downloadPath){
      
      if(this.props.successDownloads.length > 0){
        let finishedDownloadObj = this.props.successDownloads.find(download => download.path == this.state.downloadPath);

        if(finishedDownloadObj){
          this.setState({downloadPath: null});
          
          this._initialize();
        }
      }
      if(this.props.errorDownloads.length > 0){
        
        let finishedDownloadObj = this.props.errorDownloads.find(download => download.path == this.state.downloadPath);
        
        if(finishedDownloadObj){
          this.setState({downloadPath: null});
          this._initialize();
        }
        
      }
    }
  }

  _initialize() {
    this.setState({ generating: false });
    this.props.dataActions.clearDataFile(CLIENTS);
  }
  
  buildDescription(clientName, values) {
    
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";
    let billingPeriodDates =  "";
    let reportType = "";

    let billingPeriod = this.props.billingPeriods.find(
      (billingPeriod) => billingPeriod.billingPeriodId == values.billingPeriodId
    );
    let translationFile;

    
    if (userLanguage == "fr-CA") {
      translationFile = frenchTranslations;
    }
    else{
      translationFile = englishTranslations;
    }

    if(values.startingBillingPeriodId){
      let billingPeriodStart = this.props.billingPeriods.find(
        (billingPeriod) => billingPeriod.billingPeriodId == values.startingBillingPeriodId
      );
      let billingPeriodEnd = this.props.billingPeriods.find(
        (billingPeriod) => billingPeriod.billingPeriodId == values.endingBillingPeriodId
      );
        billingPeriodDates = billingPeriodStart.startDate + " - " + billingPeriodStart.endDate + "\n" + billingPeriodEnd.startDate + " - " + billingPeriodEnd.endDate;
    }

    if(billingPeriod){
      billingPeriodDates = billingPeriod.startDate + " - " + billingPeriod.endDate;
    }

    if(values.coverageCertificateType){
      reportType = this.getCoverageCertificateType(values.coverageCertificateType, translationFile);
    }

    else if(values.payrollFrequency){
      reportType = this.getPayrollType(values.payrollFrequency, translationFile);
    }

    let reportName = this.getReportType(values.reportType, translationFile);
    
    return (
      translationFile.downloader.clientReport +
      ": " +
      clientName +
      "\n" +
      billingPeriodDates +
      "\n" +
      reportName +
      "" +
      reportType +
      ": " +
      values.languageCode
    );
  }

  getPayrollType(value, translationFile){
    let payrollType;

    switch(value){
      case "WEEKLY":
        payrollType =  translationFile.downloader.weekly;
        break;
      case "BIWEEKLY":
        payrollType = translationFile.downloader.biweekly;
        break;
      case "SEMIMONTHLY":
        payrollType = translationFile.downloader.semiMonthly;
        break;
      case "MONTHLY":
        payrollType = translationFile.downloader.monthly;
        break;
      case "ANNUAL":
        payrollType = translationFile.downloader.yearly;
        break;
    }

    if(payrollType){
      payrollType += ",";
    }

    return payrollType;

  }

  getCoverageCertificateType(value, translationFile){
    switch(value){
      case "PROVINCE":
        return translationFile.downloader.provinces;
      case "DIVISION":
        return translationFile.downloader.divisions;
    }
  }

  getReportType(value, translationFile) {

    switch (value) {
      case "DEPENDENT_PERSON_COVERAGES_TERMINATIONS":
        return translationFile.downloader.maximumAge;
      case "TAX_BENEFITS":
        return translationFile.downloader.taxBenefit;
      case "COVERAGE_CERTIFICATE":
        return translationFile.downloader.certificateByCoverage;
      case "COVERAGE_STATUSES":
        return translationFile.downloader.coverageStatus;
      case "ENEL_REPORT":
        return translationFile.downloader.enelReport;
      case "PAYROLL_DEDUCTIONS":
        return translationFile.downloader.payroll;
    }

  }

  onSubmit(values) {
    const {
      client: { clientId },
      dataActions,
    } = this.props;
    const path = `${clientId}/reports/`;
    const body = { ...values, createCookie: true };
    const headers = { "Accept-Language": values.languageCode };
    const description =  this.buildDescription(this.props.client.name, body);

    return dataActions
      .postDataFile(CLIENTS, path, body, headers)
      .then((data) => {
        if (data.type !== POST_DATA_FILE_FAILURE) {
          if(canDownload(description, this.props.currentDownloads)){
            this.setState({ generating: true });
            this.setState({downloadPath: this.props.shortLivedURL});
            this.props.downloaderActions.downloadFile(
              this.props.shortLivedURL,
              description
            );
          }
          else{
            toast(
              <FormattedMessage id="downloader.duplicateDownload" values={{ file: description, br: <br/>}} />,
              {
                type: toast.TYPE.ERROR,
                autoClose: downloaderEnums.AUTO_CLOSE,
              }
            );
          }
        }
      });
  }

  render() {
    const {
      client: { clientId, clientStatusType },
      generating,
    } = this.props;

    return (
      <div className="sub-content">
        <ClientReportsForm
          clientId={clientId}
          clientStatusType={clientStatusType}
          onSubmit={this.onSubmit}
          generating={generating || this.state.generating}
        />
      </div>
    );
  }
}

ClientReportsPage.propTypes = {
  client: PropTypes.object,
  cookieName: PropTypes.string,
  dataActions: PropTypes.object,
  generating: PropTypes.bool,
  shortLivedURL: PropTypes.string,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  billingPeriods: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  currentDownloads: PropTypes.array,
  downloaderActions: PropTypes.object,
};

function mapStateToProps(state) {
  const clients = state.data.clients || {};
  const file = clients.shortLivedURL || {};
  const billingPeriods = state.data.billingPeriods || {};
  const downloads = state.downloader || {};

  return {
    client: clients.active || {},
    cookieName: file.cookieName || null,
    generating: state.data.submitting,
    shortLivedURL: file.fileUrl || null,
    billingPeriods: billingPeriods.items || {},
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
    currentDownloads: downloads.files || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientReportsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/ClientReportsPage.js